<template>
  <div>
    <PTCLink
      :to="`/en/resource-center/events/`"
      class="rounded-md bg-www-color-accent-soft px-3 py-6px font-ptc-Rajdhani text-15px font-bold uppercase leading-none tracking-[0.45px] text-www-color-accent-light"
    >
      ← Back to all Events
    </PTCLink>
  </div>
</template>

<script setup>
import PTCLink from '~/components/Atoms/PTCLink/PTCLink.vue';
// note to this doesn't handle translated pages and if we change the events url
// we have to change this as well
</script>
